import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useArchivedCoursePageSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.ARCHIVED_COURSE_PAGE_SETTINGS(),
    queryFn: () => shopApi.fetchArchivedCoursePageSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.ARCHIVED_COURSE_PAGE_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    archivedCoursePageSettings: data?.data,
    invalidate,
  };
};
